
import Order from '@components/order/models/list/Order';
import OrderingEnvironmentType from '@components/order/models/list/OrderingEnvironmentType';
import PointOfSaleTwoToneIcon from '@mui/icons-material/PointOfSaleTwoTone';
import { Box } from '@mui/material';
import React from 'react';

interface EnvironmentTypeProps {
    order: Order;
}

const EnvironmentType: React.FC<EnvironmentTypeProps> = ({ order }) => {
    if (order.environmentType === OrderingEnvironmentType.webApp) {
        return null;
    }
    return (
        <Box position={"absolute"} right={4} top={4}>
            <PointOfSaleTwoToneIcon fontSize='small' />
        </Box>
    )
}

export default EnvironmentType;